import cn from 'classnames'
import React from 'react'
import { THEME } from 'src/config/config'

interface Props {
  className?: string
  label?: string
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const EnhancedTag: React.FC<Props> = ({ label }) => {
  if (label === 'SolutionCarousel') {
    return (
      <span
        className={cn(
          'inline-flex',
          THEME === 'ilta' &&
            'justify-center items-center px-3 h-[20px] w-[82px] text-[0.8125rem] font-primary font-bold text-center !rounded-full bg-[#CCE3FF] !font-tertiary font-semibold',
          THEME === 'legaltech' &&
            'justify-center items-center text-textdark text-[12px] font-secondary font-bold h-5 w-[82px] text-center leading-5 tracking-[0.5px] rounded bg-[#29EF97]',
        )}
      >
        Enhanced
      </span>
    )
  } else {
    return (
      <span
        className={cn(
          'inline-flex mr-[10px]',
          THEME === 'ilta' &&
            'justify-center items-center px-3 h-[20px] w-[82px] text-[0.8125rem] font-primary font-bold text-center !rounded-full bg-[#CCE3FF] !font-tertiary font-semibold',
          THEME === 'legaltech' &&
            'justify-center items-center text-textdark text-[12px] font-secondary font-bold h-5 w-[82px] text-center leading-5 tracking-[0.5px] rounded bg-[#29EF97]',
        )}
      >
        Enhanced
      </span>
    )
  }
}
